import { IModule, IModuleAction } from "../../shared/interfaces/module/IModule";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { requests } from "../../utils/api/api.service";
import { MODULE_URL } from "../../utils/api/endpoints";

export const ModuleService = {
  get: (pagination: IPagination): Promise<IBaseModel<IModule[]>> =>
    requests.get(MODULE_URL, pagination),
  getSingle: (id: number): Promise<IModule> =>
    requests.get(`${MODULE_URL}/${id}`),
  create: (params: IModuleAction) => requests.post(MODULE_URL, params),
  update: (params: IModuleAction, id: number) =>
    requests.put(`${MODULE_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${MODULE_URL}/${id}`),
};
